var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12" }, [
    _c("div", [_c("h3", [_vm._v(_vm._s(_vm.course.title))])]),
    _vm._v(" "),
    _c("div", [
      _c("b", [
        _vm._v(_vm._s(_vm._f("translate")("Number of invites left")) + ":"),
      ]),
      _vm._v(" " + _vm._s(_vm.licencesLeft)),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("small", [
        _vm._v(
          _vm._s(
            _vm._f("translate")(
              "If you want to participate - please add your email address below"
            )
          )
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "my-5" }, [
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "border-0" }, [
              _vm._v(_vm._s(_vm._f("translate")("Name"))),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "border-0" }, [_vm._v("Email")]),
            _vm._v(" "),
            _c("th", { staticClass: "border-0" }, [_vm._v("Status")]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.invitations, function (invitation) {
              return _c("tr", { key: invitation.id }, [
                _c("td", [_vm._v(_vm._s(invitation.name))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(invitation.email))]),
                _vm._v(" "),
                _c("td", { staticClass: "d-flex justify-content-between" }, [
                  _c("div", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")(invitation.status)) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  invitation.status === "sent"
                    ? _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openModal(invitation)
                            },
                          },
                        },
                        [
                          _c(
                            "button",
                            { staticClass: "btn btn-outline-danger btn-sm" },
                            [_vm._v("X")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm.licencesLeft
              ? _c("tr", [
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: _vm.$t("Name") },
                      domProps: { value: _vm.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.name = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Email" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.email = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-primary",
                        on: { click: _vm.create },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("translate")("Invite")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("Are you sure?"))),
                ]),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Do you realy want to delete this invitation?")
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.hideModal },
                  },
                  [_vm._v(_vm._s(_vm.$t("Cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.confirmDelete },
                  },
                  [_vm._v(_vm._s(_vm.$t("Delete")))]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }